export enum GiftCardDeliveryScheduleEnum {
  INSTANT = 1,
  FUTURE = 2
}
